import { useEffect, useState } from 'react';
import {TechStackContent} from './styles';
import { TechItem } from '../TechItem';

interface Tech{
    id: number,
    name: string,
    icon: string
}
export function TechStack(){
    const [skills, setSkills] = useState<Tech[]>([]);

    useEffect(()=>{
        fetch('./services/skills.json',{
            headers:{
                Accept: "application/json"
            }
        }).then(response => response.json())
        .then( data => setSkills(data.skills))
    },[])
    return(
        <TechStackContent>
            <h3>Tech Stack</h3>
            <ul>
                {skills.map(skill => {
                    return(<TechItem key={skill.id} TechItem={skill}/>)
                })}
            </ul>
        </TechStackContent>
    )
}